import { collectAttributes } from './utils';

export function unitList(state, getters, rootState, rootGetters) {
  const {
    activeFilters,
    filterCheckers,
  } = getters;

  return rootGetters['units/normalizedUnits'].filter(unit => filterUnit(unit, activeFilters, filterCheckers));
}

export function filterOverlays(state, getters, rootState, rootGetters) {
  const {
    'units/normalizedUnitById': unitById,
  } = rootGetters;
  const {
    activeFilters,
    filterCheckers,
  } = getters;

  return overlays => overlays.filter((overlay) => {
    if (overlay.disabled) {
      return false;
    }

    if (!activeFilters.length) {
      return true;
    }

    if (!overlay.unit_id) {
      return false;
    }

    const unit = unitById(overlay.unit_id);

    if (!unit) {
      return false;
    }

    return filterUnit(unit, activeFilters, filterCheckers);
  });
}

// ///////////////////////////////////
function filterUnit(unit, activeFilters, filterCheckers) {
  return activeFilters.every(filter => passFilter(
    filter.value,
    collectAttributes(unit)[filter.key],
    filter.component,
    filterCheckers,
  ));
}

function passFilter(values, attribute, component, filterCheckers) {
  if (!attribute) {
    return false;
  }

  const lcAttribute = attribute.toLowerCase();

  if (filterCheckers.isCheckBox(component)) {
    return values.filter(elm => elm.toLowerCase() === lcAttribute).length;
  }

  if (filterCheckers.isSingleCheckBox(component)) {
    return values.some(value => value.toLowerCase() === lcAttribute);
  }

  return values
    && values.length
    && (!values[0] || parseInt(values[0], 10) <= attribute)
    && (!values[1] || parseInt(values[1], 10) >= attribute);
}
